// Public classes.
export {NgxSmartModalService} from './services/ngx-smart-modal.service';
export {NgxSmartModalComponent} from './components/ngx-smart-modal.component';
export {NgxSmartModalModule} from './modules/ngx-smart-modal.module';
export {NgxSmartModalConfig, INgxSmartModalOptions} from './config/ngx-smart-modal.config';
export {ModalInstance} from './services/modal-instance';
